import React from 'react'
import { TicketContextType } from './TicketContextType'

const TicketContext = React.createContext<TicketContextType|null>( null )

export default TicketContext